
import * as React from 'react';
import {FormattedMessage} from 'react-intl';

import {Margin, HeadlineLevel} from 'features/ui/enums';

import './style.scss';

import { P } from '@atoms/Text/P';
import {Icon} from 'components/atoms/Media/Icon';
import {ButtonLink} from 'components/atoms/LinksAndButtons/ButtonLink';
import { ButtonColor, ButtonSize, ButtonType } from '@atoms/LinksAndButtons/Button';
import {Headline} from '@atoms/Text/Headline';

interface Props {
    url:string;
}

export const ParkingLink: React.FunctionComponent<Props> = ({url}) => {
    return (
        <div className="parking-link dark-bg">
            <Headline level={HeadlineLevel.H2} margin={Margin.L}><FormattedMessage id="jm.components.ParkingLink.headline" /></Headline>
            <P><FormattedMessage id="jm.components.ParkingLink.text" /></P>
            <ButtonLink 
                href={url} 
                buttonColor={ButtonColor.LIGHT} 
                buttonSize={ButtonSize.DEFAULT} 
                buttonType={ButtonType.DEFAULT} 
                icon={<Icon name="arrow-link" up size={24} />}
            >
                <FormattedMessage id="jm.components.ParkingLink.buttonText" />
            </ButtonLink>
        </div>
    );
};
